var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOfferIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#offer-icon_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "#FFDB00",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "M11.359 15.56c-1.9 0-3.36-1.44-3.36-3.28S9.459 9 11.359 9s3.34 1.44 3.34 3.28-1.44 3.28-3.34 3.28m-.81 7.26a1.104 1.104 0 0 1-.189-1.55l8.799-11.24a1.104 1.104 0 1 1 1.739 1.36l-8.799 11.241c-.376.48-1.07.565-1.55.19m.81-9.18c.7 0 1.22-.6 1.22-1.36s-.52-1.36-1.22-1.36-1.22.6-1.22 1.36.52 1.36 1.22 1.36m8.58 9.96c-1.9 0-3.36-1.44-3.36-3.28s1.46-3.28 3.36-3.28 3.34 1.44 3.34 3.28-1.44 3.28-3.34 3.28m0-1.92c.7 0 1.22-.6 1.22-1.36s-.52-1.36-1.22-1.36-1.22.6-1.22 1.36.52 1.36 1.22 1.36"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "offer-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
export default SvgOfferIcon;